import { createContext, useCallback, useContext, useReducer } from "react";

import searchReducer, { initialState } from "./reducer";

const SearchContext = createContext(initialState);

export const SearchProvider = ({ children }) => {
  const [state, dispatch] = useReducer(searchReducer, initialState);

  const updateSearchParameters = (parameters) => {
    dispatch({ type: "SEARCH_UPDATE_PARAMETERS", payload: { parameters } });
  };

  const addTagSearch = (tag) => {
    dispatch({ type: "SEARCH_ADD_TAG", payload: { tag } });
  };

  const clearSearchParameters = useCallback(() => {
    dispatch({ type: "SEARCH_CLEAR_PARAMETERS" });
  }, [dispatch]);

  const saveSearch = (data) => {
    dispatch({ type: "SEARCH_SAVE", payload: { data } });
  };

  const setActiveSavedSearch = (data) => {
    dispatch({
      type: "SEARCH_SET_ACTIVE_SAVED_SEARCH",
      payload: { data },
    });
  };

  const setDisplayAsList = (displayAsList) => {
    dispatch({
      type: "SEARCH_SET_DISPLAY_AS_LIST",
      payload: { displayAsList },
    });
  };

  const addNewRegAssistSubsession = (payload) => {
    dispatch({
      type: "SEARCH_REGASSIST_SEARCH_GENERATION",
      payload,
    });
  };

  const selectRegAssistSearchType = (searchType) => {
    dispatch({ type: "SEARCH_REGASSIST_SEARCH_TYPE", payload: { searchType } });
  };

  const addRegAssistQuestion = (payload) => {
    dispatch({ type: "SEARCH_ADD_REGASSIST_QUESTION", payload });
  };

  const handleRegAssistResponse = (payload) => {
    dispatch({ type: "SEARCH_REGASSIST_HANDLE_RESPONSE", payload });
  };

  const handleRegAssistError = (payload) => {
    dispatch({ type: "SEARCH_REGASSIST_HANDLE_ERROR", payload });
  };

  const resetRegAssistHistory = () => {
    dispatch({ type: "SEARCH_REGASSIST_RESET_HISTORY" });
  };

  const registerLoadedComponent = (componentName) => {
    dispatch({
      type: "REGISTER_LOADED_COMPONENT",
      payload: { componentName },
    });
  };

  const value = {
    activeSavedSearch: state.activeSavedSearch,
    addNewRegAssistSubsession,
    addRegAssistQuestion,
    addTagSearch,
    componentsLoaded: state.componentsLoaded,
    clearSearchParameters,
    displayAsList: state.displayAsList,
    handleRegAssistError,
    handleRegAssistResponse,
    regAssist: state.regAssist,
    registerLoadedComponent,
    resetRegAssistHistory,
    saveSearch,
    searchParameters: state.parameters,
    selectRegAssistSearchType,
    setActiveSavedSearch,
    setDisplayAsList,
    updateSearchParameters,
  };

  return (
    <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
  );
};

const useSearchContext = () => {
  const searchContext = useContext(SearchContext);

  if (searchContext === undefined) {
    throw new Error("useSearchContext must be used within SearchContext");
  }

  return searchContext;
};

export default useSearchContext;
